module.exports = __webpack_public_path__ + "static/img/codeZh.83afc6c7.png";